<template>
  <div class="section form-stepper">
    <div class="form-stepper__box grid section__wrapper">
      <div
        class="grid__wrapper grid grid--1 grid--gt-l--2 form-stepper__header"
      >
        <div class="grid__item">
          <div class="content form-stepper__title" id="step">
            <span id="step"
              class="content__heading mod mod--size--42 mod--weight--300"
              v-html="currentStep.title"
            ></span>
          </div>
        </div>
        <div class="grid__item">
          <div class="stepper">
            <template v-for="(step, index) in steps">
              <div
                class="stepper__separator"
                v-if="index !== 0"
                :class="{
                  'stepper__item--active': index <= currentIndex
                }"
                :key="'separator' + index"
              ></div>
              <div
                class="stepper__item"
                :class="{
                  'stepper__item--active': index <= currentIndex
                }"
                :key="'item' + index"
                @click="goToStep(index)"
              >
                {{ index + 1 }}
                <span class="stepper__label">{{ step.label }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div>
        <div
          v-for="(step, index) in steps"
          :key="step.template"
          v-show="index == currentIndex"
        >
          <div class="section__wrapper">
            <div class="section__block form-stepper__content">
              <div class="container">
                <div class="form-stepper__container">
                  <div class="form">
                    <slot
                      :name="step.template"
                      v-bind="{
                        next:
                          index < steps.length - 1
                            ? () => goToStep(index + 1)
                            : null,
                        prev: index > 0 ? () => goToStep(index - 1) : null
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "stepper",
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    activeStep: {
      type: [String, Number],
      default: 0
    }
  },
  data: self => ({
    currentIndex: parseInt(self.activeStep)
  }),
  methods: {
    goToStep: function(index) {
      const step = this.steps[index];

      if (step.enabled && !step.enabled()) {
        return;
      }

      this.currentIndex = index;
    }
  },
  computed: {
    currentStep() {
      return this.steps[this.currentIndex];
    }
  }
};
</script>

<style scoped>
.form-stepper__box {
  max-width: 720px !important;
}
.form-stepper__title {
  margin: 0 1rem;
}
.form-stepper__header {
  margin-bottom: 2rem;
}
.form-stepper__content {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 2em;
}
.form-stepper__container {
  box-sizing: border-box;
  padding: 1rem;
  width: 100%;
}
</style>
